import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useCart } from "../context/CartContext";
import { IkonMenu } from "./Ikon";
import { asalNavigasiHp } from "./navigasiHp";

// Menu bawah 5 tombol (papan B1d, B7, B10, B11). Akun → /akun bila sudah masuk, /login bila belum.
// Admin tidak punya keranjang/pesanan pembeli → Panel menggantikan keduanya.
export function MenuBawah() {
  const { user } = useAuth();
  const { count } = useCart();
  const lokasi = useLocation();
  const { pathname } = lokasi;
  const admin = user?.role === "admin";
  const aktif = (p) => (p === "/" ? pathname === "/" : pathname === p || pathname.startsWith(`${p}/`));

  const item = [
    { to: "/", label: "Beranda", kunci: "/" },
    { to: "/katalog", label: "Katalog", kunci: "/katalog" },
    ...(admin ? [{ to: "/admin", label: "Panel", kunci: "/admin" }] : [
      { to: "/keranjang", label: "Keranjang", kunci: "/keranjang", badge: count },
      { to: "/pesanan", label: "Pesanan", kunci: "/pesanan" },
    ]),
    { to: "/akun", label: "Akun", kunci: user ? "/akun" : "/login" },
  ];

  return (
    <nav aria-label="Menu utama" className="hp-menu" style={{ gridTemplateColumns: `repeat(${item.length}, minmax(0, 1fr))` }} data-testid="hp-menu-bawah">
      {item.map(({ to, label, kunci, badge }) => {
        const on = aktif(kunci);
        const Ikon = IkonMenu[label];
        const perluMasuk = !user && ["/keranjang", "/pesanan", "/akun"].includes(to);
        return (
          <Link key={label} to={perluMasuk ? "/login" : to} state={perluMasuk ? { from: to, ...asalNavigasiHp(lokasi) } : to === "/keranjang" ? asalNavigasiHp(lokasi) : undefined} aria-current={on ? "page" : undefined} aria-label={badge > 0 ? `${label}, ${badge} produk` : undefined} className={`hp-menu__item${on ? " is-aktif" : ""}`}
            data-testid={`hp-menu-${label.toLowerCase()}`}>
            {on && <span aria-hidden="true" className="hp-menu__garis" />}
            <Ikon garis={on ? "#1D1D1F" : "currentColor"} tebal={on ? 2 : 1.8} />
            {label}
            {badge > 0 && <span className="hp-menu__badge" data-testid="hp-menu-badge">{badge}</span>}
          </Link>
        );
      })}
    </nav>
  );
}
